/**
 * React Router configuration for the app shell (spec.md § Routing & pages):
 *   `/`           → mints a new pad, redirects to `/p/:slug`.
 *   `/p/:slug`    → the pad screen (top bar + editor).
 *   `*`           → the shared "not found or expired" page.
 *
 * Uses a data router (`createBrowserRouter`). Route components default-export
 * per React Router convention (AGENTS.md § Code style). The route table is
 * exported separately so tests can mount it under a `createMemoryRouter`.
 */

import { createBrowserRouter, type RouteObject } from "react-router-dom";
import IndexRoute from "./IndexRoute";
import PadRoute from "./PadRoute";
import NotFoundRoute from "./NotFoundRoute";

export const routes: RouteObject[] = [
  { path: "/", element: <IndexRoute /> },
  { path: "/p/:slug", element: <PadRoute /> },
  { path: "*", element: <NotFoundRoute /> },
];

export const router = createBrowserRouter(routes);
